import React from 'react';

export interface ITextProps {
  className?: String;
  children: String;
}

const Text = (props: ITextProps) => {
  const { children } = props;
  let { className }: any = props;

  className = !!!className || className.lenght < 1  ? '' : `${className}`;

  return (
    <p className={`text ${className}`}>
      {children}
    </p>
  );
}

export default Text;